import { COUNTRIES_LIST } from "../constants/api-path";
import httpClient from "./http.interceptor";

/**
 * @param {page: number, limit: number, sortColumn: string|number, sortDirection: string } formData
 * @returns Promise<any>
 */
export const getAppCountries = (formData: any): Promise<any> => {
  return httpClient.get(COUNTRIES_LIST, {
    params: {
      page: formData.page,
      pageSize: formData.limit,
      sort: formData.sort,
      search: formData.search,
    },
  });
};
